import React, { useEffect, useRef } from 'react';
import { motion, useInView, useReducedMotion, useScroll, useTransform } from 'framer-motion';
import { showreel } from '../data/showreel';
const EASE = [0.23, 1, 0.32, 1] as const;

/**
 * Full-screen showreel above the footer: fades into view once, then loops the reel (muted).
 * Only plays while on screen; reduced motion shows a still first frame.
 * The video drifts inside the frame like a window (parallax); the footer below handles the unveil.
 */
export function WorkFlash() {
  const reduce = useReducedMotion();
  const ref = useRef<HTMLElement>(null);
  const videoRef = useRef<HTMLVideoElement>(null);
  // Starts fading in as soon as the frame's top edge peeks over the bottom of the screen
  const shown = useInView(ref, {
    once: true,
    amount: 0,
    margin: '0px 0px -4% 0px'
  });
  const onScreen = useInView(ref, {
    amount: 0.1
  });

  // Across the frame's whole trip through the screen, the video drifts the opposite way to the scroll
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start end', 'end start']
  });
  const parallaxY = useTransform(scrollYProgress, [0, 1], reduce ? ['0%', '0%'] : ['-12%', '12%']);

  // Play only while visible, so it never costs anything off screen
  useEffect(() => {
    const v = videoRef.current;
    if (!v) return;
    if (onScreen && !reduce) v.play().catch(() => {});else v.pause();
  }, [onScreen, reduce]);
  return <section ref={ref} aria-label="Our showreel" className="relative h-[70vh] min-h-[364px] w-full overflow-hidden bg-black" data-id="element-308" data-mp="alyuhtwsb6as">
      {/* Window parallax: the layer is taller than the frame so its edges never show */}
      <motion.div className="absolute inset-x-0 -inset-y-[16%] will-change-transform" style={{
      y: parallaxY
    }} data-id="element-309" data-mp="vx8r8rwlzz1">
        <motion.div className="absolute inset-0" initial={reduce ? false : {
        opacity: 0,
        scale: 1.04
      }} animate={shown ? {
        opacity: 1,
        scale: 1
      } : undefined} transition={{
        opacity: {
          duration: 0.9,
          ease: EASE
        },
        scale: {
          duration: 1.3,
          ease: EASE
        }
      }} data-id="element-310" data-mp="3sx3fzzcq2ame">
          <video ref={videoRef} src={showreel.videoSrc} muted loop playsInline preload="auto" aria-label="Immersive Studios showreel" className="absolute inset-0 h-full w-full object-cover" data-id="element-311" data-mp="39fhcj501se9z" />
        </motion.div>
      </motion.div>
    </section>;
}